import React, { useEffect, useState } from 'react';
import { Col, Row, Card, Input } from 'antd';
import { FaExchangeAlt, FaChevronRight } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import { getFlightDomesticList } from '../../../services/flight/flightServices';
import moment from 'moment';
import { flight_video_img } from '../../../utils/ImagePath';

const PopularDomesticFlight = () => {
    const [domesticData, setDomesticData] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    const fetchDomesticData = async () => {
        try {
            const data = await getFlightDomesticList();
            setDomesticData(data?.data || []);
        } catch (err) {
            setError('Failed to fetch domestic flights');
        }
    };

    useEffect(() => {
        fetchDomesticData();
    }, []);

    const formattedTomorrow = moment().add(1, 'days').format('DD/MMM/YYYY');

    const handleFlightClick = (flight) => {
        sessionStorage.setItem('selectFromCity', JSON.stringify(flight?.from_city));
        sessionStorage.setItem('selectFromCityName', JSON.stringify(flight?.from_city_airport));
        sessionStorage.setItem('selectTOCity', JSON.stringify(flight?.to_city));
        sessionStorage.setItem('selectTOCityName', JSON.stringify(flight?.to_city_airport));
        sessionStorage.setItem('seatTypeflight', JSON.stringify("ECONOMY"));
        sessionStorage.setItem('returnFlight', JSON.stringify('oneWay'));
        sessionStorage.setItem('DepartureFlight', JSON.stringify(formattedTomorrow));
        sessionStorage.setItem('selectAdultsflight', JSON.stringify(1));
        sessionStorage.setItem('selectChildflight', JSON.stringify(0));
        sessionStorage.setItem('selectInfantsflight', JSON.stringify(0));
        const urlIdDynamic = `${flight?.from_city.toLowerCase()}-to-${flight?.to_city.toLowerCase()}-flights`;
        navigate(`/flights/${urlIdDynamic}`);
    };

    // Filter flights based on search input
    const filteredFlights = domesticData.filter((flight) =>
        flight.from_city.toLowerCase().includes(searchText.toLowerCase()) ||
        flight.to_city.toLowerCase().includes(searchText.toLowerCase())
    );

    return (
        <>
            <section className='PackageBanner py-5'>
                <img  rel="preload" as="image" src={flight_video_img} alt='Banner-Background' type="image/avif" fetchpriority="high" />
                <div className='container'>
                    <Row gutter={16} align="middle">
                        <Col md={24} sm={24}>
                            <div className='Package-cntr'>
                                <h2 className='mb-0 fs-1'>Popular Domestic Destinations</h2>
                            </div>
                        </Col>
                    </Row>
                </div>
            </section>

            <section className="flight-area py-5">
                <div className="container">
                    <Card title="Popular Domestic Destinations" extra={
                        <Input
                            type='text'
                            className='form-control'
                            placeholder='Search by city name...'
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                            style={{ height: '40px', padding: '10px 15px' }}
                        />
                    }>
                        <Row gutter={20} className="section-title mb-3 d-none">
                            <Col md={16}>
                                <h3>Popular Domestic Destinations</h3>
                            </Col>
                            <Col md={8}>
                                <Input
                                    type='text'
                                    className='form-control'
                                    placeholder='Search by city name...'
                                    value={searchText}
                                    onChange={(e) => setSearchText(e.target.value)}
                                    style={{ height: '45px', padding: '10px 15px' }}
                                />
                            </Col>
                        </Row>
                        {filteredFlights.length === 0 ? (
                            <div className="no-results">
                                <p>No destinations found. Try a different search term.</p>
                            </div>
                        ) : (
                            <Row gutter={20}>
                                {filteredFlights.map((flight) => {
                                    const urlIdDynamic = `${flight.from_city.toLowerCase()}-to-${flight.to_city.toLowerCase()}-flights`;
                                    return (
                                        <Col key={flight.id} lg={8} md={12} xs={24}>
                                            <div className="card flight-box" onClick={() => handleFlightClick(flight)}>
                                                <div className="card-body">
                                                    <div className="deal-title d-flex align-items-center justify-content-between">
                                                        <div className="d-flex align-items-center gap-1">
                                                            <h3 className="deal__title py-2">
                                                                <span className="d-flex align-items-center">
                                                                    {flight.from_city} <FaExchangeAlt className="mx-2" /> {flight.to_city}
                                                                </span>
                                                            </h3>
                                                        </div>
                                                        <FaChevronRight className='fs-6 m-0' />
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                    );
                                })}
                            </Row>
                        )}
                    </Card>
                </div>
            </section>
        </>
    );
}

export default PopularDomesticFlight;
